import {t} from '../catalogueUi';

/**
 * The form error of a switch out of the dealer price list (unpublish, deactivate, disable) that also
 * changes the price: the server refuses it (DMS-NV-CT-0054), so nothing is sent.
 */
export const statusWithPriceError = (name: string) => ({
  name,
  message: t(
    'entity.newVehicle.catalogue.itemChange.statusWithPrice',
    'Save the status change and the price change separately. A published model year sets the price through a price adjustment.'
  ),
});
